var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"aspect-16x9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":_vm.video,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }